export function money(value: string | number, currency = "CAD"): string {
  const n = typeof value === "string" ? Number(value) : value;
  if (Number.isNaN(n)) return String(value);
  return new Intl.NumberFormat("en-CA", { style: "currency", currency }).format(n);
}

export function today(): string {
  // Deterministic-free: derive from the client clock at call time (UI only).
  const d = new Date();
  return d.toISOString().slice(0, 10);
}

export function statusTone(status: string): string {
  const s = status.toUpperCase();
  if (["P", "POSTED", "PAID", "APPROVED", "MATCHED", "COMPLETE", "INVOICED"].includes(s)) return "ok";
  if (["D", "OPEN", "READY", "IDENTIFIED", "DRAFT", "PARTIAL"].includes(s)) return "pending";
  if (["X", "CANCELLED", "DENIED", "MATCH_EXCEPTION", "WRITTEN_OFF"].includes(s)) return "bad";
  return "";
}
